import { styled } from '@porsche-code/kado-styled-system/jsx';

export const ButtonGroup = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 'md',
  },

  variants: {
    direction: {
      row: {
        flexDirection: 'row',
      },
      column: {
        flexDirection: 'column',
        flexWrap: 'nowrap',
      },
    },
  },
});
